export default "__VITE_ASSET__Am7bxB5k__"